import { createLabeledMessages } from '@gef-ui/localization/messageUtils';

const userSearch = {
	title: 'Výsledek vyhledání uživatele',
	firstName: 'Jméno uživatele',
	login: 'Login uživatele',
	sellerIn: 'Seznam získatelských čísel',
	profession: 'Profese',
};

export default Object.assign({}, userSearch, createLabeledMessages(userSearch));
